import { render, staticRenderFns } from "./QuotationPanel.vue?vue&type=template&id=71d8fc42&scoped=true"
import script from "./QuotationPanel.vue?vue&type=script&lang=js"
export * from "./QuotationPanel.vue?vue&type=script&lang=js"
import style0 from "./QuotationPanel.vue?vue&type=style&index=0&id=71d8fc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8fc42",
  null
  
)

export default component.exports